import styled, { css } from 'styled-components';
import { color, size, animation } from './helpers/variables';
import { fontFamilyBody } from './helpers/mixins';

export const Pagination = styled.button`
  ${fontFamilyBody};
  border: none;
  background-color: transparent;
  padding: 10px 2px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2px;
  color: ${color.black};
  border-bottom: 1px solid transparent;
  margin: 0 10px;
  outline: 0;
  opacity: 0.31;
  transition: opacity ${animation.transitionTime} ${animation.easing};

  &:hover {
    opacity: 1;
  }

  ${props =>
    props.active &&
    css`
      opacity: 1;
      border-bottom-color: ${color.black};
    `};

  @media screen and (min-width: ${size.medium}px) {
    font-size: 14px;
  }
`;

export const PaginationDivider = styled.div`
  color: ${color.black};
  opacity: 0.31;
  padding: 0;
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/styles/Pagination.js